/* Custom product submit handler for capture specific products  ( Video, Film, Photo, Digital Media, Album Scan ) */
/* Brought over from existing infrastructure */
/* Should ideally be refactored because there is a lot of complex logic right now */

var defineProductObject = function (type, id, quantity, timeStamp, formData) {
	var product;
	if (type === "tapes") {
		quantity =
			formData.find((formData) => formData.name == "video-quantity")
				?.value ?? 0;

		product = {
			id: id,
			quantity: quantity,
			properties: {
				data: {
					name: "inputs",
					value: {
						type: type,
						dvd_copies: 0,
						dvd_options: {
							theme: null,
							music: null,
						},
						title: null, // ignored for tape, since we use customizations for each tape
						quantity: quantity, // must match number if elements in customizations array
						customizations: [],
					},
				},
				timeStamp: {
					date: timeStamp,
				},
				additional: {
					estimate: {
						total:
							parseInt(
								formData.find(function (item) {
									return item.name === "estimatedTotal";
								})?.value
							) ?? null,
					},
				},
				upsells: {
					dvd: {
						id: null,
						quantity: 0,
					},
				},
			},
		};
	} else if (type === "images") {
		product = {
			id,
			quantity: 0,
			properties: {
				data: {
					name: "inputs",
					value: {
						type: type,
						dvd_copies: 0,
						dvd_options: {
							theme: null,
							music: null,
						},
						title: null, // title for this transfer no matter how many reels.
						quantity: null, // should be combined quantity of all reel sizes
						customizations: [],
					},
				},
				timeStamp: {
					date: timeStamp,
				},
				additional: {
					"additional-products": [
						{
							id:
								parseInt(
									formData.find(function (item) {
										return item.name === "extra-photo";
									})?.value
								) ||
								parseInt(
									formData.find(function (item) {
										return item.name === "extra";
									}).value
								) ||
								null,
							quantity: 0,
						},
						{
							id:
								parseInt(
									formData.find(function (item) {
										return item.name === "extra-photo";
									})?.value
								) ||
								parseInt(
									formData.find(function (item) {
										return item.name === "extra";
									}).value
								) ||
								null,
							quantity: 0,
						},
						{
							id:
								parseInt(
									formData.find(function (item) {
										return item.name === "extra-photo";
									})?.value
								) ||
								parseInt(
									formData.find(function (item) {
										return item.name === "extra";
									}).value
								) ||
								null,
							quantity: 0,
						},
					],
					estimate: {
						total:
							parseInt(
								formData.find(function (item) {
									return item.name === "estimatedTotal";
								}).value
							) || null,
					},
				},
				upsells: {
					dvd: {
						id: null,
						quantity: 0,
					},
				},
			},
		};

		return product;
	} else if (type === "films") {
		var filmQuantity = 0;
		for (i = 0; i < formData.length; i++) {
			if (formData[i].name === "film-quantity") {
				var formValue = parseInt(formData[i].value);

				if (formValue > 0) {
					filmQuantity += formValue;
				}
			}
		}

		product = {
			id,
			quantity: filmQuantity,
			properties: {
				data: {
					name: "inputs",
					value: {
						type: type, // needs to be 'films' for film reels
						dvd_copies: 0,
						dvd_options: {
							theme: null,
							music: null,
						},
						title: null, // title for this transfer no matter how many reels.
						quantity: filmQuantity, // should be combined quantity of all reel sizes
						actual_audio: false, // is actual audio
						media_date: null, // media date for this transfer
						customizations: [],
					},
				},
				timeStamp: {
					date: timeStamp,
				},
				additional: {
					id:
						parseInt(
							formData.find(function (item) {
								return item.name === "extra-film";
							})?.value
						) ||
						parseInt(
							formData.find(function (item) {
								return item.name === "extra";
							}).value
						) ||
						null,
					quantity: 0,
					reels: filmQuantity,
					estimate: {
						total:
							parseInt(
								formData.find(function (item) {
									return item.name === "estimatedTotal";
								})?.value
							) ?? null,
					},
				},
				upsells: {
					dvd: {
						id: null,
						quantity: 0,
					},
				},
			},
		};
	} else if (type === "digital_media") {
		quantity =
			formData.find((formData) => formData.name == "digital-quantity")
				?.value ?? 0;

		product = {
			id,
			quantity,
			properties: {
				data: {
					name: "inputs",
					value: {
						type: type,
						dvd_copies: 0,
						dvd_options: {
							theme: null,
							music: null,
						},
						title: null, // title for digital media.
						quantity,
						customizations: [],
					},
				},
				timeStamp: {
					date: timeStamp,
				},
				additional: {
					estimate: {
						total:
							parseInt(
								formData.find(function (item) {
									return item.name === "estimatedTotal";
								}).value
							) || null,
					},
				},
				upsells: {
					dvd: {
						id: null,
						quantity: 0,
					},
				},
			},
		};
	} else if (type === "album_scan") {
		let quantity = 0;
		let albumQuantity = 0;
		let albumAmounts = [];

		for (i = 0; i < formData.length; i++) {
			if (formData[i].name === "album-quantity") {
				var formValue = parseInt(formData[i].value);
				quantity = quantity + formValue;

				if (formValue > 0) {
					albumQuantity = albumQuantity + 1;
					albumAmounts.push(formValue);
				}
			}
		}

		product = {
			id,
			quantity: albumQuantity,
			properties: {
				data: {
					name: "inputs",
					value: {
						type: type,
						dvd_copies: 0,
						dvd_options: {
							theme: null,
							music: null,
						},
						customizations: [],
					},
				},
				timeStamp: {
					date: timeStamp,
				},
				additional: {
					estimate: {
						total:
							parseInt(
								formData.find(function (item) {
									return item.name === "estimatedTotal";
								})?.value
							) ?? null,
					},
					albumTotal: {
						quantity: albumQuantity,
					},
					albumAmounts: [...albumAmounts],
				},
				upsells: {
					dvd: {
						id: null,
						quantity: 0,
					},
				},
			},
		};
	}

	return product;
};

var getCartItems = function (type, id, quantity, formData, existingTimestamp) {
	// generate timestamp for products
	var timeStamp = existingTimestamp || new Date();

	// array for storing our products to add to cart
	var cartItems = [];

	var product = defineProductObject(type, id, quantity, timeStamp, formData);
	var titles = formData.filter(
		(formData) => formData.name == "memories-title"
	);
	var dates = formData
		.filter((formData) => formData.name == "memories-date")
		.map((date) => {
			if (date?.value?.length) {
				const object = {
					name: date.name,
					getAttribute: (arg) => date.getAttribute(arg),
					value: date.value.replaceAll("-", "/"),
				};
				return object;
			}
			return date;
		});

	if (titles.length || dates.length) {
		// add customizations
		if (type === "tapes") {
			//tapes product logic
			var rewind = formData.filter(
				(formData) => formData.name == "memories-rewind"
			);
			for (let i = 0; i < product.quantity; i++) {
				var titleValue = titles[i]?.value ?? "";
				var dateValue = dates[i]?.value ?? "";
				var rewindValue = rewind[i]?.checked ?? true;
				var customizationObject = {
					title: "",
					rewind: rewindValue,
					media_date: null,
				};
				if (titleValue?.length) {
					customizationObject.title = titleValue;
				}
				if (dateValue?.length) {
					customizationObject.media_date = dateValue;
				}
				product.properties.data.value.customizations.push(
					customizationObject
				);
			}
		} else if (type === "images") {
			//photo product logic

			// //additional product object
			var additionalPrintProduct = {
				id:
					parseInt(
						formData.find(function (item) {
							return item.name === "extra-photo";
						})?.value
					) ||
					parseInt(
						formData.find(function (item) {
							return item.name === "extra";
						}).value
					) ||
					null,
				quantity: 0,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
				},
			};

			var additionalSlideProduct = {
				id:
					parseInt(
						formData.find(function (item) {
							return item.name === "extra-slide";
						})?.value
					) || null,
				quantity: 0,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
				},
			};

			var additionalNegativeProduct = {
				id:
					parseInt(
						formData.find(function (item) {
							return item.name === "extra-negative";
						})?.value
					) || null,
				quantity: 0,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
				},
			};

			// check the quantity of each type of photos
			var limit = CONSTANTS.PHOTO.THRESHOLD;
			var prints = formData.find(function (item) {
				return (
					item.name === "photo-quantity" &&
					item?.getAttribute("data-photo-type") == "Prints"
				);
			})?.value || "0";
			var slides = formData.find(function (item) {
				return (
					item.name === "photo-quantity" &&
					item?.getAttribute("data-photo-type") == "Slides"
				);
			})?.value || "0";
			var negatives = formData.find(function (item) {
				return (
					item.name === "photo-quantity" &&
					item?.getAttribute("data-photo-type") == "Negatives"
				);
			})?.value || "0";
			var total =
				parseInt(prints) + parseInt(slides) + parseInt(negatives);

			var additionalPrints = 0;
			var additionalSlides = 0;
			var additionalNegatives = 0;

			product.properties.data.value.quantity = total;

			// check for photo types, if photo type has more then zero quantity we add a core product
			if (prints && prints > 0) {
				product.quantity += 1;

				// get customization info and update data customization
				var printTitle =
					titles.find(
						(title) =>
							title.getAttribute("data-photo-type") == "Prints"
					)?.value ?? "";
				var printDate =
					dates.find(
						(date) =>
							date.getAttribute("data-photo-type") == "Prints"
					)?.value ?? null;

				product.properties.data.value.customizations.push({
					sku: "TRX-PRT-C80",
					quantity: prints,
					media_date: printDate,
					title: printTitle,
				});

				if (parseInt(prints) > parseInt(limit)) {
					additionalPrints = additionalPrints + (prints - limit);
				}
			}

			if (slides && slides > 0) {
				product.quantity += 1;
				// get customization info and update data customization
				var slideTitle =
					titles.find(
						(title) =>
							title.getAttribute("data-photo-type") == "Slides"
					)?.value ?? "";
				var slideDate =
					dates.find(
						(date) =>
							date.getAttribute("data-photo-type") == "Slides"
					)?.value ?? null;

				product.properties.data.value.customizations.push({
					sku: "TRX-SLD-C80",
					quantity: slides,
					media_date: slideDate,
					title: slideTitle,
				});

				if (parseInt(slides) > parseInt(limit)) {
					additionalSlides = additionalSlides + (slides - limit);
				}
			}

			if (negatives && negatives > 0) {
				product.quantity += 1;
				var negativeTitle =
					titles.find(
						(title) =>
							title.getAttribute("data-photo-type") == "Negatives"
					)?.value ?? "";
				var negativeDate =
					dates.find(
						(date) =>
							date.getAttribute("data-photo-type") == "Negatives"
					)?.value ?? null;

				product.properties.data.value.customizations.push({
					sku: "TRX-NEG-C80",
					quantity: negatives,
					media_date: negativeDate,
					title: negativeTitle,
				});

				if (parseInt(negatives) > parseInt(limit)) {
					additionalNegatives =
						additionalNegatives + (negatives - limit);
				}
			}
			if (prints <= 0 && slides <= 0 && negatives <= 0) {
				product.quantity += 1;
				product.properties.data.value.customizations.push({
					sku: "TRX-PRT-C80",
					quantity: 1,
					media_date: null,
					title: "",
				});
			}
		} else if (type === "films") {
			//film product logic
			// //additional product object
			var additionalProduct = {
				id:
					parseInt(
						formData.find(function (item) {
							return item.name === "extra-film";
						})?.value
					) ||
					parseInt(
						formData.find(function (item) {
							return item.name === "extra";
						}).value
					) ||
					null,
				quantity: 0,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
				},
			};
			var filmFeetTotal = 0;
			for (i = 0; i < formData.length; i++) {
				if (formData[i].name === "film-quantity") {
					var formValue = parseInt(formData[i].value);
					var feetValue = Number(
						formData[i].getAttribute("data-feet")
					);

					if (formValue > 0) {
						filmFeetTotal += formValue * feetValue;
					}
				}
			}
			// // check limit against totalft for the order
			if (CONSTANTS.FILM.THRESHOLD < filmFeetTotal) {
				// update product additional values if over the limit
				product.quantity = 1;
				product.properties.additional.quantity =
					filmFeetTotal - CONSTANTS.FILM.THRESHOLD;

				// update additional product quantity
				additionalProduct.quantity =
					filmFeetTotal - CONSTANTS.FILM.THRESHOLD;
			} else {
				product.quantity = 1;
			}

			//update product data customization
			product.properties.data.value.customizations.push(
				{
					sku: "TRX-FLC-S03",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 3
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S04",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 4
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S05",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 5
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S06",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 6
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S07",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 7
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S08",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 8
							);
						})?.value ?? 0,
				},
				{
					sku: "TRX-FLC-S10",
					quantity:
						formData.find(function (item) {
							return (
								item.name == "film-quantity" &&
								item?.getAttribute("data-reel") == 10
							);
						})?.value ?? 0,
				}
			);
			var firstTitle = titles[0].value;
			var firstDate = dates[0].value;
			if (firstTitle) product.properties.data.value.title = firstTitle;
			if (firstDate) product.properties.data.value.media_date = firstDate;

			var actualAudio = formData.find(function (item) {
				return item.name == "original-audio";
			})?.checked;
			//update original audio
			if (actualAudio)
				product.properties.data.value.actual_audio = actualAudio;
		} else if (type === "digital_media") {
			for (let i = 0; i < product.quantity; i++) {
				var titleValue = titles[i]?.value ?? "";
				var dateValue = dates[i]?.value ?? "";
				var customizationObject = {
					title: "",
					media_date: null,
				};
				if (titleValue?.length) {
					customizationObject.title = titleValue;
				}
				if (dateValue?.length) {
					customizationObject.media_date = dateValue;
				}
				product.properties.data.value.customizations.push(
					customizationObject
				);
			}
		} else if (type === "album_scan") {
			for (let i = 0; i < product.quantity; i++) {
				var titleValue = titles[i]?.value ?? "";
				var dateValue = dates[i]?.value ?? "";
				var customizationObject = {
					title: "",
					quantity: product.properties.additional.albumAmounts[i],
					media_date: null,
				};
				if (titleValue?.length) {
					customizationObject.title = titleValue;
				}
				if (dateValue?.length) {
					customizationObject.media_date = dateValue;
				}
				product.properties.data.value.customizations.push(
					customizationObject
				);
			}
		}
	}

	cartItems.push(product);

	if (additionalProduct && type != "images" && type != "album_scan") {
		cartItems.push(additionalProduct);
	} else if (
		additionalPrintProduct &&
		additionalSlideProduct &&
		additionalNegativeProduct &&
		type === "images"
	) {
		if (additionalPrints > 0) {
			// update product additional values if over the limit
			product.properties.additional["additional-products"][0].quantity =
				additionalPrints;

			// update additional product quantity
			additionalPrintProduct.quantity = additionalPrints;

			cartItems.push(additionalPrintProduct);
		}

		if (additionalSlides > 0) {
			// update product additional values if over the limit
			product.properties.additional["additional-products"][1].quantity =
				additionalSlides;

			// update additional product quantity
			additionalSlideProduct.quantity = additionalSlides;

			cartItems.push(additionalSlideProduct);
		}

		if (additionalNegatives > 0) {
			// update product additional values if over the limit
			product.properties.additional["additional-products"][2].quantity =
				additionalNegatives;

			// update additional product quantity
			additionalNegativeProduct.quantity = additionalNegatives;

			cartItems.push(additionalNegativeProduct);
		}
	} else if (type === "album_scan") {
		for (let b = 0; b < product.quantity; b++) {
			if (
				parseInt(product.properties.additional.albumAmounts[b]) >
				CONSTANTS.ALBUM.THRESHOLD
			) {
				// Add additional product
				var additionalProduct = {
					id:
						parseInt(
							formData.find(function (item) {
								return item.name === "extra-album";
							})?.value
						) ||
						parseInt(
							formData.find(function (item) {
								return item.name === "extra";
							}).value
						) ||
						null,
					quantity:
						parseInt(
							product.properties.additional.albumAmounts[b]
						) - CONSTANTS.ALBUM.THRESHOLD,
					properties: {
						timeStamp: {
							date: timeStamp,
						},
						for: "Album Scanning " + (b + 1),
					},
				};

				cartItems.push(additionalProduct);
			}
		}
	}

	// dvd upsell object ( only if quantity of dvd is greater than zero )
	var dvdID =
		formData.find(function (item) {
			return item.name === "upsellDVDID";
		})?.value ?? 0;
	var dvdQuantity =
		formData.find(function (item) {
			return item.name === "dvd-quantity";
		})?.value ?? 0;
	var dvdTotal = dvdQuantity;

	if (dvdID && dvdQuantity && dvdQuantity > 0 && type === "tapes") {
		// we push a new dvd line for each quantity of the product so they are on their own line_items
		for (var i = 0; i < product.quantity; i++) {
			cartItems.push({
				id: dvdID,
				quantity: dvdQuantity,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
					for: "Video Transfer" + (i + 1),
				},
			});
		}

		product.properties.data.value.dvd_copies = dvdTotal;
	} else if (dvdID && dvdQuantity && dvdQuantity > 0 && type === "images") {
		// we push a new dvd line for each quantity of the product so they are on their own line_items
		for (var i = 0; i < product.quantity; i++) {
			cartItems.push({
				id: dvdID,
				quantity: dvdQuantity,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
					for: "Photo Transfer" + (i + 1),
				},
			});
		}
		product.properties.data.value.dvd_copies = dvdQuantity;
	} else if (dvdID && dvdQuantity && dvdQuantity > 0 && type === "films") {
		var dvds = {
			id: dvdID,
			quantity: dvdQuantity,
			properties: {
				timeStamp: {
					date: timeStamp,
				},
				for: "Film Transfer",
			},
		};

		product.properties.data.value.dvd_copies = dvdQuantity;

		// add product to cart array
		cartItems.push(dvds);
	} else if (
		dvdID &&
		dvdQuantity &&
		dvdQuantity > 0 &&
		type === "digital_media"
	) {
		// push a new dvd line item for each quantity of the dvd that is equal to the quantity of the dvd product.
		for (var i = 0; i < product.quantity; i++) {
			cartItems.push({
				id: dvdID,
				quantity: dvdQuantity,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
					for: "Digital Media Transfer" + (i + 1),
				},
			});
		}

		product.properties.data.value.dvd_copies = dvdTotal;
	} else if (
		dvdID &&
		dvdQuantity &&
		dvdQuantity > 0 &&
		type === "album_scan"
	) {
		for (var i = 0; i < product.quantity; i++) {
			cartItems.push({
				id: dvdID,
				quantity: dvdQuantity,
				properties: {
					timeStamp: {
						date: timeStamp,
					},
					for: "Album Scanning" + (i + 1),
				},
			});
		}
		product.properties.data.value.dvd_copies = dvdQuantity;
	}

	// Add DVD theme
	if (dvdID && dvdQuantity && dvdQuantity > 0) {
		var themeOption =
			formData.find(function (item) {
				return item.name === "theme-outputs" && item.checked == true;
			})?.value ?? 0;
		if (themeOption) {
			product.properties.data.value.dvd_options.theme = themeOption;
		}
		var defaultMusicOption = "MIS-BMU-NOM";
		var musicOption =
			formData.find(function (item) {
				return item.name === "music-outputs" && item.checked == true;
			})?.value ?? defaultMusicOption;
		if (musicOption) {
			product.properties.data.value.dvd_options.music = musicOption;
		}
	}

	// usb upsell object ( only if quantity of dvd is greater than zero )
	var usbID =
		formData.find(function (item) {
			return item.name === "upsellUSBID";
		})?.value ?? 0;

  var quantityElement = formData.find(function (item) {
		return item.name === "usb-quantity";
	});

  var inCart = quantityElement?.getAttribute("data-incart") == "true";
  var usbQuantity = quantityElement?.getAttribute("data-added") ?? 0;

  // only add to cartItems when no in cart already
	if (usbID && usbQuantity > 0 && !inCart) {
		cartItems.push({
			id: usbID,
			quantity: usbQuantity,
			properties: {
				timeStamp: {
					date: timeStamp,
				},
				for: type,
			},
		});
	}
  // enhanced content upsell object ( only if not in cart)

  var enhancedContentID =
    formData.find(function (item) {
      return item.name === "upsellEnhancedContentID";
  	})?.value ?? 0;

  var quantityElement = formData.find(function (item) {
  			return item.name === "enhanced-content-quantity";
  		});

  var inCart = quantityElement?.getAttribute("data-incart") == "true";

  var enhancedContentQuantity = quantityElement?.getAttribute("data-added") ?? 0;

  // only add to cartItems when no in cart already
  if (enhancedContentID && enhancedContentQuantity > 0 && !inCart) {
  	cartItems.push({
  		id: enhancedContentID,
  		quantity: enhancedContentQuantity,
  		properties: {
  			timeStamp: {
  				date: timeStamp,
  			},
  			for: "entire order",
  		},
  	});
  }



	// cart items to add
	return cartItems;
};